
// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { toast } from "react-toastify";

// const Sidebar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [openDropdowns, setOpenDropdowns] = useState({
//     dashboard: false,
//     fundManagement: false,
//     registrationTeam: false,
//     incomeEarnings: false,
//     bonanzaRewards: false,
//     airdrop: false,
//     withdrawal: false,
//     settings: false,
//   });

//   const [activeMenu, setActiveMenu] = useState({
//     mainMenu: null,
//     subMenu: null,
//   });

//   // Map routes to menu items
//   const routeToMenuMap = {
//    "/dashboard": { main: "dashboard", sub: "quantum-dashboard" },
//   "/ecosystem/working": { main: "dashboard", sub: "working-ecosystem" },
//   "/ecosystem/roi-qi": { main: "dashboard", sub: "roi-qi-ecosystem" },
//   "/ecosystem/gaming": { main: "dashboard", sub: "gaming-ecosystem" },
//   "/ecosystem/token": { main: "dashboard", sub: "token-ecosystem" },

//     "/bond/add-bond": { main: "bond", sub: "add-bond" },
//   "/bond/used-bond": { main: "bond", sub: "used-bond" },
//   "/bond/unused-bond": { main: "bond", sub: "unused-bond" },
    
//     // Fund Management routes
//     "/fund-management/fuel-deposit": { main: "fundManagement", sub: "fuel-deposit" },
//      "/payment-report": { main: "fundManagement", sub: "payment-report" },
//      "/plan-upgrade-report": { main: "fundManagement", sub: "plan-upgrade-report" },
//     "/wallet-transfer": { main: "fundManagement", sub: "wallet-transfer" },
//     "/fund-management/re-topup": { main: "fundManagement", sub: "re-topup" },
//     "/wallet-transaction": { main: "fundManagement", sub: "wallet-transaction" },
    
//    "/registration/new-joining": { main: "registrationTeam", sub: "new-joining" },
//   "/registration/crowd-signups": { main: "registrationTeam", sub: "crowd-signups" },
//   "/registration/direct-leads": { main: "registrationTeam", sub: "direct-leads" },
//   "/registration/team-network": { main: "registrationTeam", sub: "team-network" },
  
//   // Income & Earnings
//   "/income/level-income": { main: "incomeEarnings", sub: "level-income" },
//   "/income/team-income": { main: "incomeEarnings", sub: "team-income" },
//   "/income/senior-retopup-income": { main: "incomeEarnings", sub: "senior-retopup" },
//   "/income/cmd-bonus": { main: "incomeEarnings", sub: "cmd-bonus" },
//   "/income/24-max-directs": { main: "incomeEarnings", sub: "24-max-directs" },
//   "/income/24-max-income": { main: "incomeEarnings", sub: "24-max-income" },
//   "/income/24-lowest-income": { main: "incomeEarnings", sub: "24-lowest-income" },
//   "/income/24-zero-income": { main: "incomeEarnings", sub: "24-zero-income" },
//   "/income/roi-overview": { main: "incomeEarnings", sub: "roi-overview" },
    
//     // Bonanza & Rewards routes
//     "/bonanza/my-list": { main: "bonanzaRewards", sub: "my-list" },
//     "/bonanza/awards-rewards": { main: "bonanzaRewards", sub: "awards-rewards" },
    
//     // Airdrop routes
//     "/airdrop/qi-airdrop": { main: "airdrop", sub: "qi-airdrop" },
    
//     // Withdrawal routes
//     "/withdrawal/funds": { main: "withdrawal", sub: "withdrawal-funds" },
    
//     // Settings routes
//     "/settings/my-profile": { main: "settings", sub: "my-profile" },
//     "/settings/crypto-addresses": { main: "settings", sub: "crypto-addresses" },
//     "/settings/security": { main: "settings", sub: "security-settings" },
   
//   };

//   // Set active menu based on current route
//   useEffect(() => {
//     const currentPath = location.pathname;
//     const menuInfo = routeToMenuMap[currentPath];
    
//     if (menuInfo) {
//       setActiveMenu({
//         mainMenu: menuInfo.main,
//         subMenu: menuInfo.sub,
//       });
      
//       // Open the corresponding dropdown
//       if (!openDropdowns[menuInfo.main]) {
//         setOpenDropdowns(prev => ({
//           ...prev,
//           [menuInfo.main]: true
//         }));
//       }
//     }
//   }, [location.pathname]);

//   const toggleDropdown = (key) => {
//     setOpenDropdowns((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   const handleMainMenuClick = (mainKey) => {
//     setActiveMenu({
//       mainMenu: mainKey,
//       subMenu: null,
//     });
//     toggleDropdown(mainKey);
//   };

//   const handleSubMenuClick = (mainKey, subKey, route = null) => {
//     setActiveMenu({
//       mainMenu: mainKey,
//       subMenu: subKey,
//     });
    
//     if (route) {
//       navigate(route);
//     }
    
//     // Open the parent dropdown if not already open
//     if (!openDropdowns[mainKey]) {
//       setOpenDropdowns(prev => ({
//         ...prev,
//         [mainKey]: true
//       }));
//     }
//   };

//   // Check if a menu is active
//   const isMainMenuActive = (key) => activeMenu.mainMenu === key;
//   const isSubMenuActive = (key) => activeMenu.subMenu === key;

//   return (
//     <div className="sidebar-body">
//       <ul className="nav" id="sidebarNav">
//         {/* Dashboard */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="/dashboard"
//             className={`nav-link d-flex align-items-center justify-content-between ${
//               isMainMenuActive("dashboard") ? "main-menu-active" : ""
//             }`}
//             onClick={(e) => {
//               e.preventDefault();
//               handleMainMenuClick("dashboard");
//             }}
//             aria-expanded={openDropdowns.dashboard}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="layout-dashboard"></i>
//               <span className="link-title nav-item nav-category">
//                 Dashboard
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.dashboard ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.dashboard ? "show" : ""
//             }`}
//           >
//             {/* 1. Quantum Dashboard */}
//             <li className="nav-dropdown-item">
//               <a
//                 href="/dashboard"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("quantum-dashboard") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("dashboard", "quantum-dashboard", "/dashboard");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="zap"></i>
//                 <span className="link-title">Quantum Dashboard</span>
//               </a>
//             </li>

//             {/* 2. Working / Community Ecosystem */}
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("working-ecosystem") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   toast.info("Working / Community Ecosystem: Coming Soon!");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="users"></i>
//                 <span className="link-title">Working / Community Ecosystem</span>
//               </a>
//             </li>

//             {/* 3. ROI / QI Ecosystem */}
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("roi-qi-ecosystem") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   toast.info("ROI / QI Ecosystem: Coming Soon!");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="refresh-cw"></i>
//                 <span className="link-title">ROI / QI Ecosystem</span>
//               </a>
//             </li>

//             {/* 4. Gaming Ecosystem */}
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("gaming-ecosystem") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   toast.info("Gaming Ecosystem: Coming Soon!");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="gamepad-2"></i>
//                 <span className="link-title">Gaming Ecosystem</span>
//               </a>
//             </li>

//             {/* 5. Token / Payment Ecosystem */}
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("token-ecosystem") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   toast.info("Token / Payment Ecosystem: Coming Soon!");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="coins"></i>
//                 <span className="link-title">Token / Payment ( Token ) Ecosystem</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Airdrop */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#airdrop"
//             className={`nav-link d-flex align-items-center justify-content-between ${
//               isMainMenuActive("airdrop") ? "main-menu-active" : ""
//             }`}
//             onClick={(e) => {
//               e.preventDefault();
//               handleMainMenuClick("airdrop");
//             }}
//             aria-expanded={openDropdowns.airdrop}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="cloud-snow"></i>
//               <span className="link-title nav-item nav-category">
//                 Airdrop
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.airdrop ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${openDropdowns.airdrop ? "show" : ""}`}
//           >
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("qi-airdrop") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("airdrop", "qi-airdrop", "/airdrop/qi-airdrop");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="cloud-snow"></i>
//                 <span className="link-title">QI Airdrop</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//           <li className="nav-item has-dropdown">
//           <a
//             href="#bond"
//             className={`nav-link d-flex align-items-center justify-content-between ${
//               isMainMenuActive("bond") ? "main-menu-active" : ""
//             }`}
//             onClick={(e) => {
//               e.preventDefault();
//               handleMainMenuClick("bond");
//             }}
//             aria-expanded={openDropdowns.airdrop}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="cloud-snow"></i>
//               <span className="link-title nav-item nav-category">
//                 Bond Keys
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.airdrop ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${openDropdowns.bond ? "show" : ""}`}
//           >
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("add-bond") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("bond", "add-bond", "/bond/add-bond");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="cloud-snow"></i>
//                 <span className="link-title">Add Bond</span>
//               </a>
//             </li>
//              <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("unused-bond") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("bond", "unused-bond", "/bond/unused-bond");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="cloud-snow"></i>
//                 <span className="link-title">Unused Bond Keys</span>
//               </a>
//             </li>
//              <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("used-bond") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("bond", "used-bond", "/bond/used-bond");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="cloud-snow"></i>
//                 <span className="link-title">Used Bond Keys</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Fund Management */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#fundManagement"
//             className={`nav-link d-flex align-items-center justify-content-between ${
//               isMainMenuActive("fundManagement") ? "main-menu-active" : ""
//             }`}
//             onClick={(e) => {
//               e.preventDefault();
//               handleMainMenuClick("fundManagement");
//             }}
//             aria-expanded={openDropdowns.fundManagement}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="dollar-sign"></i>
//               <span className="link-title nav-item nav-category">
//                 Fund Management
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.fundManagement ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.fundManagement ? "show" : ""
//             }`}
//           >
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("fuel-deposit") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("fundManagement", "fuel-deposit", "/fund-management/fuel-deposit");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="fuel"></i>
//                 <span className="link-title">FuelUp / Deposit</span>
//               </a>
//             </li>
//  <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("payment-report") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("settings", "payment-report", "/payment-report");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="file-text"></i>
//                 <span className="link-title">Acount Active Report</span>
//               </a>
//             </li>
//              <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("plan-upgrade-report") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("settings", "plan-upgrade-report", "/plan-upgrade-report");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="file-text"></i>
//                 <span className="link-title">Plan Upgrade Report</span>
//               </a>
//             </li>
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("wallet-transfer") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("fundManagement", "wallet-transfer", "/wallet-transfer");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="refresh-cw"></i>
//                 <span className="link-title">Wallet-to-Wallet Transfer</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("re-topup") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("fundManagement", "re-topup", "/fund-management/re-topup");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="rotate-cw"></i>
//                 <span className="link-title">Re-TopUp (Mozumma)</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("wallet-transaction") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("fundManagement", "wallet-transaction", "/wallet-transaction");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="file-text"></i>
//                 <span className="link-title">Wallet Transaction</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Registration & Team */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="/registration/new-joining"
//             className={`nav-link d-flex align-items-center justify-content-between ${
//               isMainMenuActive("registrationTeam") ? "main-menu-active" : ""
//             }`}
//             onClick={(e) => {
//               e.preventDefault();
//               handleMainMenuClick("registrationTeam");
//             }}
//             aria-expanded={openDropdowns.registrationTeam}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="user-plus"></i>
//               <span className="link-title nav-item nav-category">
//                 Registration & Team
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.registrationTeam ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.registrationTeam ? "show" : ""
//             }`}
//           >
//             <li className="nav-dropdown-item">
//               <a
//                 href="/registration/new-joining"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("new-joining") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("registrationTeam", "new-joining", "/registration/new-joining");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="user-plus"></i>
//                 <span className="link-title">
//                   New Joining / Member Registration
//                 </span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="/registration/crowd-signups"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("crowd-signups") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("registrationTeam", "crowd-signups", "/registration/crowd-signups");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="users"></i>
//                 <span className="link-title">Crowd Sign-Ups</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="/registration/direct-leads"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("direct-leads") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("registrationTeam", "direct-leads", "/registration/direct-leads");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="user-check"></i>
//                 <span className="link-title">My Direct Leads</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="/registration/team-network"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("team-network") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("registrationTeam", "team-network", "/registration/team-network");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="network"></i>
//                 <span className="link-title">My Team Network</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Income & Earnings */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#incomeEarnings"
//             className={`nav-link d-flex align-items-center justify-content-between ${
//               isMainMenuActive("incomeEarnings") ? "main-menu-active" : ""
//             }`}
//             onClick={(e) => {
//               e.preventDefault();
//               handleMainMenuClick("incomeEarnings");
//             }}
//             aria-expanded={openDropdowns.incomeEarnings}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="trending-up"></i>
//               <span className="link-title nav-item nav-category">
//                 Income & Earnings
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.incomeEarnings ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.incomeEarnings ? "show" : ""
//             }`}
//           >
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("level-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "level-income", "/income/level-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="layers"></i>
//                 <span className="link-title">Direct Level Income</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("team-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "team-income", "/income/team-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="users"></i>
//                 <span className="link-title">Team Income</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("senior-retopup-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "senior-retopup-income", "/income/senior-retopup-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="repeat"></i>
//                 <span className="link-title">Senior Re-TopUp Income</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("cmd-bonus") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "cmd-bonus", "/income/cmd-bonus");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="award"></i>
//                 <span className="link-title">CMD Bonus</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("24-max-directs") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "24-max-directs", "/income/24-max-directs");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="bar-chart-3"></i>
//                 <span className="link-title">24 Max Directs Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("24-max-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "24-max-income", "/income/24-max-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="trending-up"></i>
//                 <span className="link-title">24 Max Income Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("24-lowest-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "24-lowest-income", "/income/24-lowest-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="trending-down"></i>
//                 <span className="link-title">24 Lowest Income Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("24-zero-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "24-zero-income", "/income/24-zero-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="minus-circle"></i>
//                 <span className="link-title">24 Zero Income Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("roi-overview") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "roi-overview", "/income/roi-overview");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="pie-chart"></i>
//                 <span className="link-title">ROI Generation Overview</span>
//               </a>
//             </li>
//           </ul>
//         </li>

// {/*        
//         <li className="nav-item has-dropdown">
//           <a
//             href="/income/level-income"
//             className={`nav-link d-flex align-items-center justify-content-between ${
//               isMainMenuActive("incomeEarnings") ? "main-menu-active" : ""
//             }`}
//             onClick={(e) => {
//               e.preventDefault();
//               handleMainMenuClick("incomeEarnings");
//             }}
//             aria-expanded={openDropdowns.incomeEarnings}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="trending-up"></i>
//               <span className="link-title nav-item nav-category">
//                 Income & Earnings
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.incomeEarnings ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.incomeEarnings ? "show" : ""
//             }`}
//           >
//             <li className="nav-dropdown-item">
//               <a
//                 href="/income/level-income"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("level-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "level-income", "/income/level-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="layers"></i>
//                 <span className="link-title">Level Income</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="/income/team-income"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("team-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "team-income", "/income/team-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="users"></i>
//                 <span className="link-title">Team Income</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="/income/senior-retopup-income"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("senior-retopup-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "senior-retopup-income", "/income/senior-retopup-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="repeat"></i>
//                 <span className="link-title">Senior Re-TopUp Income</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="/income/cmd-bonus"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("cmd-bonus") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "cmd-bonus", "/income/cmd-bonus");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="award"></i>
//                 <span className="link-title">CMD Bonus</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="/income/24-max-directs"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("24-max-directs") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "24-max-directs", "/income/24-max-directs");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="bar-chart-3"></i>
//                 <span className="link-title">24 Max Directs Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="/income/24-max-income"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("24-max-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "24-max-income", "/income/24-max-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="trending-up"></i>
//                 <span className="link-title">24 Max Income Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="/income/24-lowest-income"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("24-lowest-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "24-lowest-income", "/income/24-lowest-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="trending-down"></i>
//                 <span className="link-title">24 Lowest Income Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="/income/24-zero-income"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("24-zero-income") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "24-zero-income", "/income/24-zero-income");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="minus-circle"></i>
//                 <span className="link-title">24 Zero Income Report</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="/income/roi-overview"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("roi-overview") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("incomeEarnings", "roi-overview", "/income/roi-overview");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="pie-chart"></i>
//                 <span className="link-title">ROI Generation Overview</span>
//               </a>
//             </li>
//           </ul>
//         </li> */}


//         {/* Withdrawal */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#withdrawal"
//             className={`nav-link d-flex align-items-center justify-content-between ${
//               isMainMenuActive("withdrawal") ? "main-menu-active" : ""
//             }`}
//             onClick={(e) => {
//               e.preventDefault();
//               handleMainMenuClick("withdrawal");
//             }}
//             aria-expanded={openDropdowns.withdrawal}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="log-out"></i>
//               <span className="link-title nav-item nav-category">
//                 Withdrawal
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.withdrawal ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${
//               openDropdowns.withdrawal ? "show" : ""
//             }`}
//           >
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("withdrawal-funds") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("withdrawal", "withdrawal-funds", "/withdrawal/funds");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="log-out"></i>
//                 <span className="link-title">Withdraw Funds</span>
//               </a>
//             </li>
//           </ul>
//         </li>

//         {/* Settings */}
//         <li className="nav-item has-dropdown">
//           <a
//             href="#settings"
//             className={`nav-link d-flex align-items-center justify-content-between ${
//               isMainMenuActive("settings") ? "main-menu-active" : ""
//             }`}
//             onClick={(e) => {
//               e.preventDefault();
//               handleMainMenuClick("settings");
//             }}
//             aria-expanded={openDropdowns.settings}
//           >
//             <div className="d-flex align-items-center">
//               <i className="link-icon me-2" data-lucide="settings"></i>
//               <span className="link-title nav-item nav-category">
//                 Settings
//               </span>
//             </div>
//             <i
//               className={`dropdown-icon ${
//                 openDropdowns.settings ? "icon-rotate" : ""
//               }`}
//               data-lucide="chevron-down"
//             ></i>
//           </a>

//           <ul
//             className={`nav-dropdown ${openDropdowns.settings ? "show" : ""}`}
//           >
//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("my-profile") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("settings", "my-profile", "/settings/my-profile");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="user"></i>
//                 <span className="link-title">My Profile</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("crypto-addresses") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("settings", "crypto-addresses", "/settings/crypto-addresses");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="key"></i>
//                 <span className="link-title">Manage Crypto Addresses</span>
//               </a>
//             </li>

//             <li className="nav-dropdown-item">
//               <a
//                 href="#"
//                 className={`nav-link d-flex align-items-center ${
//                   isSubMenuActive("security-settings") ? "sub-menu-active" : ""
//                 }`}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   handleSubMenuClick("settings", "security-settings", "/settings/security");
//                 }}
//               >
//                 <i className="link-icon me-2" data-lucide="shield"></i>
//                 <span className="link-title">Security Settings</span>
//               </a>
//             </li>

           
//           </ul>
//         </li>
//       </ul>
//     </div>
//   );
// };

// export default Sidebar;
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Prevent body scroll when sidebar is open on mobile
  useEffect(() => {
    if (isMobile && isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobile, isOpen]);

  // Close sidebar on mobile when route changes
  useEffect(() => {
    if (isMobile && isOpen) {
      onClose();
    }
  }, [location.pathname, isMobile, isOpen, onClose]);

  // FIXED: Click-outside handler - Simplified and doesn't block dropdown toggles
  useEffect(() => {
    if (!isMobile || !isOpen) return;

    const handleClickOutside = (event) => {
      // Check if click is on backdrop
      if (event.target.classList.contains('sidebar-backdrop')) {
        onClose();
        return;
      }
      
      // Check if click is outside sidebar and not on navbar toggler
      if (
        sidebarRef.current && 
        !sidebarRef.current.contains(event.target) && 
        !event.target.closest('.navbar-toggler')
      ) {
        onClose();
      }
    };

    // Small delay to prevent immediate closing
    const timeoutId = setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMobile, isOpen, onClose]);

  const [openDropdowns, setOpenDropdowns] = useState({
    dashboard: false,
    fundManagement: false,
    registrationTeam: false,
    incomeEarnings: false,
    bonanzaRewards: false,
    airdrop: false,
    bond: false,
    withdrawal: false,
    settings: false,
  });

  const [activeMenu, setActiveMenu] = useState({
    mainMenu: null,
    subMenu: null,
  });

  // Routes that should open in new tab
  const NEW_TAB_ROUTES = [
    "/registration/direct-leads",
    "/registration/team-network"
  ];

  // Map routes to menu items
  const routeToMenuMap = {
    "/dashboard": { main: "dashboard", sub: "quantum-dashboard" },
    "/ecosystem/working": { main: "dashboard", sub: "working-ecosystem" },
    "/ecosystem/roi-qi": { main: "dashboard", sub: "roi-qi-ecosystem" },
    "/ecosystem/gaming": { main: "dashboard", sub: "gaming-ecosystem" },
    "/ecosystem/token": { main: "dashboard", sub: "token-ecosystem" },
    "/bond/add-bond": { main: "bond", sub: "add-bond" },
    "/bond/used-bond": { main: "bond", sub: "used-bond" },
    "/bond/unused-bond": { main: "bond", sub: "unused-bond" },
    "/fund-management/fuel-deposit": { main: "fundManagement", sub: "fuel-deposit" },
    "/payment-report": { main: "fundManagement", sub: "payment-report" },
    "/plan-upgrade-report": { main: "fundManagement", sub: "plan-upgrade-report" },
    "/wallet-transfer": { main: "fundManagement", sub: "wallet-transfer" },
    "/fund-management/re-topup": { main: "fundManagement", sub: "re-topup" },
    "/wallet-transaction": { main: "fundManagement", sub: "wallet-transaction" },
    "/registration/new-joining": { main: "registrationTeam", sub: "new-joining" },
    "/registration/crowd-signups": { main: "registrationTeam", sub: "crowd-signups" },
    "/registration/direct-leads": { main: "registrationTeam", sub: "direct-leads" },
    "/registration/team-network": { main: "registrationTeam", sub: "team-network" },
    "/registration/Genealogicaltree": { main: "registrationTeam", sub: "Genealogicaltree" },
    "/income/level-income": { main: "incomeEarnings", sub: "level-income" },
    "/income/team-income": { main: "incomeEarnings", sub: "team-income" },
    "/income/binary-income": { main: "incomeEarnings", sub: "binary-income" },
    "/income/senior-retopup-income": { main: "incomeEarnings", sub: "senior-retopup" },
    "/income/cmd-bonus": { main: "incomeEarnings", sub: "cmd-bonus" },
    "/income/24-max-directs": { main: "incomeEarnings", sub: "24-max-directs" },
    "/income/24-max-income": { main: "incomeEarnings", sub: "24-max-income" },
    "/income/24-lowest-income": { main: "incomeEarnings", sub: "24-lowest-income" },
    "/income/24-zero-income": { main: "incomeEarnings", sub: "24-zero-income" },
    "/income/roi-overview": { main: "incomeEarnings", sub: "roi-overview" },
    "/bonanza/my-list": { main: "bonanzaRewards", sub: "my-list" },
    "/bonanza/awards-rewards": { main: "bonanzaRewards", sub: "awards-rewards" },
    "/airdrop/qi-airdrop": { main: "airdrop", sub: "qi-airdrop" },
    "/withdrawal/funds": { main: "withdrawal", sub: "withdrawal-funds" },
    "/settings/my-profile": { main: "settings", sub: "my-profile" },
    "/settings/crypto-addresses": { main: "settings", sub: "crypto-addresses" },
    "/settings/security": { main: "settings", sub: "security-settings" },
  };

  // Set active menu based on current route
  useEffect(() => {
    const currentPath = location.pathname;
    const menuInfo = routeToMenuMap[currentPath];
    
    if (menuInfo) {
      setActiveMenu({
        mainMenu: menuInfo.main,
        subMenu: menuInfo.sub,
      });
      
      // Open the dropdown for active menu
      setOpenDropdowns(prev => ({
        ...prev,
        [menuInfo.main]: true
      }));
    }
  }, [location.pathname]);

  // FIXED: toggleDropdown - Only toggles the clicked dropdown, doesn't close others
  const toggleDropdown = (key, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    setOpenDropdowns((prev) => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  // FIXED: handleMainMenuClick - Simplified and stops propagation
  const handleMainMenuClick = (mainKey, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    setActiveMenu({
      mainMenu: mainKey,
      subMenu: null,
    });
    
    toggleDropdown(mainKey, event);
  };

  // FIXED: handleSubMenuClick - No longer tries to open dropdown
  const handleSubMenuClick = (mainKey, subKey, route = null, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    setActiveMenu({
      mainMenu: mainKey,
      subMenu: subKey,
    });
    
    if (route) {
      if (NEW_TAB_ROUTES.includes(route)) {
        window.open(route, '_blank');
      } else {
        navigate(route);
      }
    }
  };

  const isMainMenuActive = (key) => activeMenu.mainMenu === key;
  const isSubMenuActive = (key) => activeMenu.subMenu === key;

  return (
    <>
      {/* Mobile backdrop */}
      {isMobile && isOpen && (
        <div 
          className="sidebar-backdrop"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        />
      )}

      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`sidebar ${isOpen ? 'show' : ''}`}
        style={{
          overflowY: "auto",
          background: "linear-gradient(to bottom, #1e3a5f, #0d1b2a)",
        }}
        onClick={(e) => e.stopPropagation()} // Prevent clicks from bubbling
      >
        <div className="sidebar-body">
          <ul className="nav" id="sidebarNav">
            {/* Dashboard */}
            <li className="nav-item has-dropdown">
              <div
                className={`nav-link d-flex align-items-center justify-content-between ${
                  isMainMenuActive("dashboard") ? "main-menu-active" : ""
                }`}
                onClick={(e) => handleMainMenuClick("dashboard", e)}
                style={{ cursor: 'pointer' }}
              >
                <div className="d-flex align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-box link-icon">
                    <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                    <path d="m3.3 7 8.7 5 8.7-5"></path>
                    <path d="M12 22V12"></path>
                  </svg>
                  <span className="link-title nav-item nav-category">
                    DASHBOARD
                  </span>
                </div>
                <i className={`dropdown-icon ${openDropdowns.dashboard ? "icon-rotate" : ""}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-down link-arrow">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </i>
              </div>

              <ul className={`nav-dropdown ${openDropdowns.dashboard ? "show" : ""}`}>
                <li className="nav-dropdown-item">
                  <a
                    href="/dashboard"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("quantum-dashboard") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("dashboard", "quantum-dashboard", "/dashboard", e)}
                  >
                    <i className="link-icon me-2" data-lucide="zap"></i>
                    <span className="link-title">Quantum Dashboard</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("working-ecosystem") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      toast.info("Working / Community Ecosystem: Coming Soon!");
                    }}
                  >
                    <i className="link-icon me-2" data-lucide="users"></i>
                    <span className="link-title">Working / Community Ecosystem</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("roi-qi-ecosystem") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      toast.info("ROI / QI Ecosystem: Coming Soon!");
                    }}
                  >
                    <i className="link-icon me-2" data-lucide="refresh-cw"></i>
                    <span className="link-title">ROI / QI Ecosystem</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("gaming-ecosystem") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      toast.info("Gaming Ecosystem: Coming Soon!");
                    }}
                  >
                    <i className="link-icon me-2" data-lucide="gamepad-2"></i>
                    <span className="link-title">Gaming Ecosystem</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("token-ecosystem") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      toast.info("Token / Payment Ecosystem: Coming Soon!");
                    }}
                  >
                    <i className="link-icon me-2" data-lucide="coins"></i>
                    <span className="link-title">Token / Payment ( Token ) Ecosystem</span>
                  </a>
                </li>
              </ul>
            </li>

            {/* Airdrop */}
            <li className="nav-item has-dropdown">
              <a
                href="#airdrop"
                className={`nav-link d-flex align-items-center justify-content-between ${
                  isMainMenuActive("airdrop") ? "main-menu-active" : ""
                }`}
                onClick={(e) => handleMainMenuClick("airdrop", e)}
              >
                <div className="d-flex align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-message-square link-icon">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                  </svg>
                  <span className="link-title nav-item nav-category">
                    AIRDROP
                  </span>
                </div>
                <i className={`dropdown-icon ${openDropdowns.airdrop ? "icon-rotate" : ""}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-down link-arrow">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </i>
              </a>

              <ul className={`nav-dropdown ${openDropdowns.airdrop ? "show" : ""}`}>
                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("qi-airdrop") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("airdrop", "qi-airdrop", "/airdrop/qi-airdrop", e)}
                  >
                    <i className="link-icon me-2" data-lucide="cloud-snow"></i>
                    <span className="link-title">QI Airdrop</span>
                  </a>
                </li>
              </ul>
            </li>

            {/* Bond Keys */}
            <li className="nav-item has-dropdown">
              <a
                href="#bond"
                className={`nav-link d-flex align-items-center justify-content-between ${
                  isMainMenuActive("bond") ? "main-menu-active" : ""
                }`}
                onClick={(e) => handleMainMenuClick("bond", e)}
              >
                <div className="d-flex align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-unlock link-icon">
                    <rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect>
                    <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
                  </svg>
                  <span className="link-title nav-item nav-category">
                    BOND KEYS
                  </span>
                </div>
                <i className={`dropdown-icon ${openDropdowns.bond ? "icon-rotate" : ""}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-down link-arrow">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </i>
              </a>

              <ul className={`nav-dropdown ${openDropdowns.bond ? "show" : ""}`}>
                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("add-bond") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("bond", "add-bond", "/bond/add-bond", e)}
                  >
                    <i className="link-icon me-2" data-lucide="cloud-snow"></i>
                    <span className="link-title">Add Bond</span>
                  </a>
                </li>
                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("unused-bond") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("bond", "unused-bond", "/bond/unused-bond", e)}
                  >
                    <i className="link-icon me-2" data-lucide="cloud-snow"></i>
                    <span className="link-title">Unused Bond Keys</span>
                  </a>
                </li>
                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("used-bond") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("bond", "used-bond", "/bond/used-bond", e)}
                  >
                    <i className="link-icon me-2" data-lucide="cloud-snow"></i>
                    <span className="link-title">Used Bond Keys</span>
                  </a>
                </li>
              </ul>
            </li>

            {/* Fund Management */}
            <li className="nav-item has-dropdown">
              <a
                href="#fundManagement"
                className={`nav-link d-flex align-items-center justify-content-between ${
                  isMainMenuActive("fundManagement") ? "main-menu-active" : ""
                }`}
                onClick={(e) => handleMainMenuClick("fundManagement", e)}
              >
                <div className="d-flex align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-book link-icon">
                    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"></path>
                  </svg>
                  <span className="link-title nav-item nav-category">
                    FUND MANAGEMENT
                  </span>
                </div>
                <i className={`dropdown-icon ${openDropdowns.fundManagement ? "icon-rotate" : ""}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-down link-arrow">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </i>
              </a>

              <ul className={`nav-dropdown ${openDropdowns.fundManagement ? "show" : ""}`}>
                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("fuel-deposit") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("fundManagement", "fuel-deposit", "/fund-management/fuel-deposit", e)}
                  >
                    <i className="link-icon me-2" data-lucide="fuel"></i>
                    <span className="link-title">FuelUp / Deposit</span>
                  </a>
                </li>
                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("payment-report") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("fundManagement", "payment-report", "/payment-report", e)}
                  >
                    <i className="link-icon me-2" data-lucide="file-text"></i>
                    <span className="link-title">Account Active Report</span>
                  </a>
                </li>
                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("plan-upgrade-report") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("fundManagement", "plan-upgrade-report", "/plan-upgrade-report", e)}
                  >
                    <i className="link-icon me-2" data-lucide="file-text"></i>
                    <span className="link-title">Plan Upgrade Report</span>
                  </a>
                </li>
                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("wallet-transfer") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("fundManagement", "wallet-transfer", "/wallet-transfer", e)}
                  >
                    <i className="link-icon me-2" data-lucide="refresh-cw"></i>
                    <span className="link-title">Wallet-to-Wallet Transfer</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("re-topup") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("fundManagement", "re-topup", "/fund-management/re-topup", e)}
                  >
                    <i className="link-icon me-2" data-lucide="rotate-cw"></i>
                    <span className="link-title">Re-TopUp (Mozumma)</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("wallet-transaction") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("fundManagement", "wallet-transaction", "/wallet-transaction", e)}
                  >
                    <i className="link-icon me-2" data-lucide="file-text"></i>
                    <span className="link-title">Wallet Transaction</span>
                  </a>
                </li>
              </ul>
            </li>

            {/* Registration & Team */}
            <li className="nav-item has-dropdown">
              <a
                href="#registrationTeam"
                className={`nav-link d-flex align-items-center justify-content-between ${
                  isMainMenuActive("registrationTeam") ? "main-menu-active" : ""
                }`}
                onClick={(e) => handleMainMenuClick("registrationTeam", e)}
              >
                <div className="d-flex align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-smile link-icon">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
                    <line x1="9" x2="9.01" y1="9" y2="9"></line>
                    <line x1="15" x2="15.01" y1="9" y2="9"></line>
                  </svg>
                  <span className="link-title nav-item nav-category">
                    REGISTRATION & TEAM
                  </span>
                </div>
                <i className={`dropdown-icon ${openDropdowns.registrationTeam ? "icon-rotate" : ""}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-down link-arrow">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </i>
              </a>

              <ul className={`nav-dropdown ${openDropdowns.registrationTeam ? "show" : ""}`}>
                <li className="nav-dropdown-item">
                  <a
                    href="/registration/new-joining"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("new-joining") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("registrationTeam", "new-joining", "/registration/new-joining", e)}
                  >
                    <i className="link-icon me-2" data-lucide="user-plus"></i>
                    <span className="link-title">
                      New Joining / Member Registration
                    </span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="/registration/crowd-signups"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("crowd-signups") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("registrationTeam", "crowd-signups", "/registration/crowd-signups", e)}
                  >
                    <i className="link-icon me-2" data-lucide="users"></i>
                    <span className="link-title">Crowd Sign-Ups</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="/registration/direct-leads"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("direct-leads") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("registrationTeam", "direct-leads", "/registration/direct-leads", e)}
                  >
                    <i className="link-icon me-2" data-lucide="user-check"></i>
                    <span className="link-title">My Direct Leads</span>
                    <i className="ms-2" data-lucide="external-link" style={{ width: '14px', height: '14px' }}></i>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="/registration/team-network"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("team-network") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("registrationTeam", "team-network", "/registration/team-network", e)}
                  >
                    <i className="link-icon me-2" data-lucide="network"></i>
                    <span className="link-title">My Team Network</span>
                    <i className="ms-2" data-lucide="external-link" style={{ width: '14px', height: '14px' }}></i>
                  </a>
                </li>
                <li className="nav-dropdown-item">
                  <a
                    href="/registration/Genealogicaltree"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("Genealogicaltree") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("registrationTeam", "Genealogicaltree", "/registration/Genealogicaltree", e)}
                  >
                    <i className="link-icon me-2" data-lucide="network"></i>
                    <span className="link-title">Genealogical Tree</span>
                    <i className="ms-2" data-lucide="external-link" style={{ width: '14px', height: '14px' }}></i>
                  </a>
                </li>
              </ul>
            </li>

            {/* Income & Earnings */}
            <li className="nav-item has-dropdown">
              <a
                href="#incomeEarnings"
                className={`nav-link d-flex align-items-center justify-content-between ${
                  isMainMenuActive("incomeEarnings") ? "main-menu-active" : ""
                }`}
                onClick={(e) => handleMainMenuClick("incomeEarnings", e)}
              >
                <div className="d-flex align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-book link-icon">
                    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"></path>
                  </svg>
                  <span className="link-title nav-item nav-category">
                    INCOME & EARNINGS
                  </span>
                </div>
                <i className={`dropdown-icon ${openDropdowns.incomeEarnings ? "icon-rotate" : ""}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-down link-arrow">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </i>
              </a>

              <ul className={`nav-dropdown ${openDropdowns.incomeEarnings ? "show" : ""}`}>
                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("level-income") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("incomeEarnings", "level-income", "/income/level-income", e)}
                  >
                    <i className="link-icon me-2" data-lucide="layers"></i>
                    <span className="link-title">Direct Level Income</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("team-income") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("incomeEarnings", "team-income", "/income/team-income", e)}
                  >
                    <i className="link-icon me-2" data-lucide="users"></i>
                    <span className="link-title">Team Income</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("binary-income") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("incomeEarnings", "binary-income", "/income/binary-income", e)}
                  >
                    <i className="link-icon me-2" data-lucide="users"></i>
                    <span className="link-title">Binary Income</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("senior-retopup-income") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("incomeEarnings", "senior-retopup-income", "/income/senior-retopup-income", e)}
                  >
                    <i className="link-icon me-2" data-lucide="repeat"></i>
                    <span className="link-title">Senior Re-TopUp Income</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("cmd-bonus") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("incomeEarnings", "cmd-bonus", "/income/cmd-bonus", e)}
                  >
                    <i className="link-icon me-2" data-lucide="award"></i>
                    <span className="link-title">CMD Bonus</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("24-max-directs") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("incomeEarnings", "24-max-directs", "/income/24-max-directs", e)}
                  >
                    <i className="link-icon me-2" data-lucide="bar-chart-3"></i>
                    <span className="link-title">24 Max Directs Report</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("24-max-income") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("incomeEarnings", "24-max-income", "/income/24-max-income", e)}
                  >
                    <i className="link-icon me-2" data-lucide="trending-up"></i>
                    <span className="link-title">24 Max Income Report</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("24-lowest-income") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("incomeEarnings", "24-lowest-income", "/income/24-lowest-income", e)}
                  >
                    <i className="link-icon me-2" data-lucide="trending-down"></i>
                    <span className="link-title">24 Lowest Income Report</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("24-zero-income") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("incomeEarnings", "24-zero-income", "/income/24-zero-income", e)}
                  >
                    <i className="link-icon me-2" data-lucide="minus-circle"></i>
                    <span className="link-title">24 Zero Income Report</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("roi-overview") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("incomeEarnings", "roi-overview", "/income/roi-overview", e)}
                  >
                    <i className="link-icon me-2" data-lucide="pie-chart"></i>
                    <span className="link-title">ROI Generation Overview</span>
                  </a>
                </li>
              </ul>
            </li>

            {/* Withdrawal */}
            <li className="nav-item has-dropdown">
              <a
                href="#withdrawal"
                className={`nav-link d-flex align-items-center justify-content-between ${
                  isMainMenuActive("withdrawal") ? "main-menu-active" : ""
                }`}
                onClick={(e) => handleMainMenuClick("withdrawal", e)}
              >
                <div className="d-flex align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-book link-icon">
                    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"></path>
                  </svg>
                  <span className="link-title nav-item nav-category">
                    WITHDRAWAL
                  </span>
                </div>
                <i className={`dropdown-icon ${openDropdowns.withdrawal ? "icon-rotate" : ""}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-down link-arrow">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </i>
              </a>

              <ul className={`nav-dropdown ${openDropdowns.withdrawal ? "show" : ""}`}>
                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("withdrawal-funds") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("withdrawal", "withdrawal-funds", "/withdrawal/funds", e)}
                  >
                    <i className="link-icon me-2" data-lucide="log-out"></i>
                    <span className="link-title">Withdraw Funds</span>
                  </a>
                </li>
              </ul>
            </li>

            {/* Settings */}
            <li className="nav-item has-dropdown">
              <a
                href="#settings"
                className={`nav-link d-flex align-items-center justify-content-between ${
                  isMainMenuActive("settings") ? "main-menu-active" : ""
                }`}
                onClick={(e) => handleMainMenuClick("settings", e)}
              >
                <div className="d-flex align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-hash link-icon">
                    <line x1="4" x2="20" y1="9" y2="9"></line>
                    <line x1="4" x2="20" y1="15" y2="15"></line>
                    <line x1="10" x2="8" y1="3" y2="21"></line>
                    <line x1="16" x2="14" y1="3" y2="21"></line>
                  </svg>
                  <span className="link-title nav-item nav-category">
                    SETTINGS
                  </span>
                </div>
                <i className={`dropdown-icon ${openDropdowns.settings ? "icon-rotate" : ""}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-down link-arrow">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </i>
              </a>

              <ul className={`nav-dropdown ${openDropdowns.settings ? "show" : ""}`}>
                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("my-profile") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("settings", "my-profile", "/settings/my-profile", e)}
                  >
                    <i className="link-icon me-2" data-lucide="user"></i>
                    <span className="link-title">My Profile</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("crypto-addresses") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("settings", "crypto-addresses", "/settings/crypto-addresses", e)}
                  >
                    <i className="link-icon me-2" data-lucide="key"></i>
                    <span className="link-title">Manage Crypto Addresses</span>
                  </a>
                </li>

                <li className="nav-dropdown-item">
                  <a
                    href="#"
                    className={`nav-link d-flex align-items-center ${
                      isSubMenuActive("security-settings") ? "sub-menu-active" : ""
                    }`}
                    onClick={(e) => handleSubMenuClick("settings", "security-settings", "/settings/security", e)}
                  >
                    <i className="link-icon me-2" data-lucide="shield"></i>
                    <span className="link-title">Security Settings</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;